export default {
  agenda: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/item/resources/props.js